import React from 'react';

const TableLegend: React.FC = () => {
  return (
    <footer className='flex flex-wrap pt-[16px] pr-[24px] pb-[16px] pl-[24px] gap-[16px] items-end self-stretch shrink-0 flex-nowrap relative z-[889]'></footer>
  );
};

export default TableLegend;
